import { Controller } from "@hotwired/stimulus";

const MD_DO_STUDENT_LEARNING_STAGE_OPTIONS = [
  "Pre-clerkship medical student",
  "Clerkship medical student",
  "4th year medical student",
  "Resident",
  "Fellowship",
];

const PA_STUDENT_LEARNING_STAGE_OPTIONS = [
  "Didactic PA student",
  "Clinical PA student",
  "Resident",
  "Practicing clinician",
];

const NP_STUDENT_LEARNING_STAGE_OPTIONS = [
  "Undergraduate nursing student",
  "NP student",
  "DNP student",
  "Resident",
  "Practicing clinician",
];

const learningStageOptionsForProgramType = (programType) => {
  if (["MD", "DO", "Other"].includes(programType)) return MD_DO_STUDENT_LEARNING_STAGE_OPTIONS;
  if (programType === "PA") return PA_STUDENT_LEARNING_STAGE_OPTIONS;
  if (programType === "NP/DNP/Nursing") return NP_STUDENT_LEARNING_STAGE_OPTIONS;
  return [];
};

const unionPreserveOrder = (arrays) => {
  const seen = new Set();
  const result = [];

  arrays.forEach((arr) => {
    arr.forEach((item) => {
      if (seen.has(item)) return;
      seen.add(item);
      result.push(item);
    });
  });

  return result;
};

export default class extends Controller {
  static targets = ["programType", "learningStage"];

  connect() {
    this.updateLearningStageOptions();
  }

  programTypeChanged() {
    this.updateLearningStageOptions();
  }

  updateLearningStageOptions() {
    const selectedProgramTypes = Array.from(this.programTypeTarget.selectedOptions).map((option) => option.value);
    const validOptions = unionPreserveOrder(
      selectedProgramTypes.map((programType) => learningStageOptionsForProgramType(programType))
    );
    const previouslySelected = new Set(
      Array.from(this.learningStageTarget.selectedOptions).map((option) => option.value)
    );

    this.learningStageTarget.innerHTML = "";

    validOptions.forEach((value) => {
      const optionElement = document.createElement("option");
      optionElement.value = value;
      optionElement.text = value;
      optionElement.selected = previouslySelected.has(value);
      this.learningStageTarget.appendChild(optionElement);
    });

    this.learningStageTarget.disabled = validOptions.length === 0;
  }
}
